import $ from '../../../utils/request'
const urlPrefix = 'assessment'
const assessmentApi = {
	pageList(searcher) {
		return $.get(urlPrefix, searcher);
	},
	getById(id) {
		return $.get(urlPrefix + "/" + id);
	},
	//考评标准 select
	getSelectList({projectId = null, stats = '1'}) {
		return $.get(urlPrefix+ "/select", {
			projectId: projectId,
			stats: stats
		});
	},
	increase(data){
		return $.post(urlPrefix, data);
	},
	modify(data) {
		return $.put(urlPrefix, data);
	},
	delete(ids) {
		return $.delete(urlPrefix + "/delete/" + ids)
	},
}

const subUrlPrefix = 'assessmentDetails'
const assessmentDetailsApi = {
	pageList(searcher) {
		return $.get(subUrlPrefix, searcher);
	},
	getById(id) {
		return $.get(subUrlPrefix + "/" + id);
	},
	getSelectList(searcher) {
		return $.get(subUrlPrefix+ "/select", searcher);
	},
	increase(data){
		return $.post(subUrlPrefix, data);
	},
	modify(data) {
		return $.put(subUrlPrefix, data);
	},
	delete(ids) {
		return $.delete(subUrlPrefix + "/delete/" + ids)
	},
}

export { assessmentApi, assessmentDetailsApi }
